"use client";

import { useEffect, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { getQueryClient } from "@/lib/queryClient";
import { followSystemTheme } from "@/lib/os/theme";

/**
 * Everything the whole app sits inside (the session lives on the signed-in shell, app/(shell)/layout.tsx).
 * ONE TooltipProvider at the 150ms delay most screens chose, so a tooltip nobody wrapped does not fall
 * back to Base UI's 600ms default; a component may still nest its own. ONE read cache (lib/queryClient.ts),
 * taken from the module rather than held in state: a render that suspends above a boundary would throw state away.
 * The light/dark class follows the OS here, so every page does, the signed-out ones (sign-in, the upload link) included.
 */
export function Providers({ children }: { children: ReactNode }) {
  useEffect(followSystemTheme, []);
  return (
    <QueryClientProvider client={getQueryClient()}>
      <TooltipProvider delay={150}>{children}</TooltipProvider>
    </QueryClientProvider>
  );
}
